import { VListItem } from '../VListItem';
import { usePickListContext } from './hook';

type VGroupListProp = {
  groupListTitle?: string;
};

const VGroupList = ({ groupListTitle }: VGroupListProp) => {
  const {
    groupList,
    maxListHeight,
    selectedGroup,
    selectGroup,
    allItemsGroup,
  } = usePickListContext();

  return (
    <VListItem
      list={[allItemsGroup, ...groupList]}
      title={groupListTitle}
      style={{
        maxHeight: maxListHeight != null ? `${maxListHeight}px` : 'none',
      }}
      value={selectedGroup}
      onChange={selectGroup}
    />
  );
};

export default VGroupList;
